import Http from '@/services/http';
import translate from '@/services/translate';
import {
  Lookup,
  BasicAsset,
  AssetsRequestByInstallations,
  AssetsByInstallationDataResponse,
  ManeuverTypesResponse,
  AssetsRequestByInstallation,
} from 'sigma-mappings';

function mapManeuverResponse(response) {
  const filteredResponse = Object.entries(response).filter(entry => !!entry[1]);
  const maneuvers = filteredResponse.map(entry => entry[0]);
  return maneuvers.map((maneuver) => {
    const maneuverEnum = response.getKeyEnumRelation(maneuver);
    return {
      id: maneuverEnum,
      name: translate(`enums.maneuver-type.${maneuverEnum}`),
      subTypes: (response[maneuver] || []).map(subType => ({
        id: subType,
        name: translate(`enums.maneuver-sub-type.${subType}`),
      })),
    };
  });
}

const urls = {
  getAssetTypes: '/tipo-ativo', // [GET] -  Obter a lista de tipos possíveis para ativo.
  getAssets: '/ativo/lookup', //  [GET] - Obter os ativos filtrados por tipo e instalação
  maneuverTypes: assetTypeId => `/tipo-ativo/${assetTypeId}/tipos-manobras`,
  assetsByInstallations: '/usuario/empresas/instalacoes/ativos',
};

export default {
  getAssetTypes() {
    const http = new Http();
    return http
      .get(urls.getAssetTypes)
      .then(({ data }) => data.map(item => new Lookup(item)));
  },
  getAssets({ assetTypeId, installationId }) {
    const http = new Http();
    const params = new AssetsRequestByInstallation({
      assetTypeId,
      installationId,
    });
    return http
      .get(urls.getAssets, { params })
      .then(({ data }) => data.map(item => new BasicAsset(item)));
  },
  getAssetsByInstallations(payload) {
    const mappedPayload = new AssetsRequestByInstallations(payload);
    const http = new Http();
    return http
      .post(urls.assetsByInstallations, mappedPayload)
      .then(({ data }) => data.map(item => new AssetsByInstallationDataResponse(item)));
  },
  getManeuverTypes(assetTypeId) {
    const http = new Http();
    return http
      .get(urls.maneuverTypes(assetTypeId))
      .then(({ data }) => {
        const response = new ManeuverTypesResponse(data);
        return mapManeuverResponse(response);
      });
  },
};
